<template>
	<div class="tag-group-sections">
		<div
			v-if="title"
			class="title"
		>
			{{ title }}
		</div>
		<SectionSwitch
			v-for="(section, idx) in sections"
			:key="`section-${idx}`"
			class="tag-group-sections--row"
			:editable="editable && section.editable"
			:value="section.enabled"
			:label="sectionLabels[section.name]"
			:section-name="section.name"
			@input="onSectionToggled(section.name, $event)"
		/>
	</div>
</template>

<script>
import SectionSwitch from '@videotools/js/one/components/TagGroups/SectionSwitch';
import { mapGetters } from 'vuex';
import SectionLabelsMixin from '@videotools/js/one/components/TagGroups/mixin/SectionLabelsMixin';

export default {
	name:       'TagGroupSections',
	components: { SectionSwitch },
	mixins:     [SectionLabelsMixin],
	props:      {
		sections: {
			type:    Array,
			default: () => [],
		},
		editable: {
			type:    Boolean,
			default: true,
		},
		title: {
			type: String,
		},
	},
	computed: {
		...mapGetters({
			isPlayerCompetition: 'event/isPlayerCompetition',
		}),
		sectionLabels() {
			return this.sections
				.reduce((acc, section) => (
					{
						...acc,
						[section.name]: this.translateSectionLabel(section.name, this.isPlayerCompetition),
					}
				), {});
		},
	},
	methods: {
		onSectionToggled(section, status) {
			this.$emit('section-toggle', { section, enabled: status });
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts.scss';

.tag-group-sections {
	.title {
		@include text-sm-2;
		color: var(--color-grey-300);
	}

	&--row:not(:last-child) {
		border-bottom: 1px solid var(--color-grey-800);
	}
}

</style>
